module.exports = __webpack_public_path__ + "media/components/SearchForm/icon-9ceec6eb2c3b8dccd1e306eb09888cf6.svg";